import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="value-option-fields"
export default class extends Controller {
  static targets = ["valueOptionSelect"];

  static values = {
    noResultsMessage: String,
  };

  valueOptionSelectTargetConnected(element) {
    new TomSelect(element, {
      searchField: ["text"],
      valueField: "id",
      sortField: "rule_type_name",
      plugins: ["dropdown_input", "remove_button"],
      maxItems: null,
      maxOptions: 100,
      render: {
        no_results: () => {
          return `<div class="no-results">${this.noResultsMessageValue}</div>`;
        },
      },
    });
  }
}
